<template>
  <Modal v-model="addSupplierLogisticsProviderModal" :title="addSupplierLogisticsProviderTitle" :transfer="false"
    :mask-closable="false" @on-visible-change="addSupplierLogisticsProviderChange">
    <div class="flex align-items-center mb24">
      <span class="red-dot">{{ $t('key1005424') }}</span>
      <Input clearable v-model.trim="carrierName" class="width_300" :placeholder="$t('key1007110')"></Input>
    </div>
    <div class="flex align-items-center mb24 ml14">
      <span>{{ $t('key1002164') }}</span>
      <RadioGroup v-model="status">
        <Radio :label="1">{{ $t('key1000462') }}</Radio>
        <Radio :label="0">{{ $t('key1000463') }}</Radio>
      </RadioGroup>
    </div>
    <template #footer>
      <Button @click="addSupplierLogisticsProviderModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" :disabled="!carrierName" @click="supplierLogisticsProviderBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'addSupplierLogisticsProviderModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      addSupplierLogisticsProviderModal: false,
      addSupplierLogisticsProviderTitle: '',
      addSupplierLogisticsProviderType: '',
      carrierName: '',
      status: 1,
      carrierId: null,
    };
  },
  methods: {
    // 初始化数据
    initSupplierLogisticsProviderData(type, obj) {
      let title = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007108'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1007109')
      };
      this.addSupplierLogisticsProviderTitle = title[type];
      this.addSupplierLogisticsProviderType = type;
      if (type === 'edit') {
        let {carrierName, status, carrierId} = obj;
        this.carrierName = carrierName;
        this.status = status;
        this.carrierId = carrierId;
      }
      this.addSupplierLogisticsProviderModal = true;
    },
    // 确定按钮
    supplierLogisticsProviderBtn() {
      const isAdd = this.addSupplierLogisticsProviderType === 'add';
      const url = isAdd ? api.post_ymsSupplierCarrier_insert : api.post_ymsSupplierCarrier_update;
      const method = 'post';
      const text = isAdd ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000776') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002665');
      const query = {
        carrierName: this.carrierName,
        status: this.status,
        ...(isAdd ? {} : {carrierId: this.carrierId})
      };
      this.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          this.addSupplierLogisticsProviderModal = false;
          this.$Message.success(text);
          this.$emit('updateData');
        }
      });
    },
    // 监听弹窗
    addSupplierLogisticsProviderChange(value) {
      if (!value) {
        this.carrierName = '';
        this.status = 1;
        this.carrierId = null;
      }
    }
  }
};
</script>

<style lang="less">

</style>
